import { render, staticRenderFns } from "./MstfAdd.vue?vue&type=template&id=54da16d0&scoped=true&"
import script from "./MstfAdd.vue?vue&type=script&lang=js&"
export * from "./MstfAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54da16d0",
  null
  
)

export default component.exports